import './style.css';
import React, { useState } from 'react'
import { Button, FormControl } from 'react-bootstrap'
import { BASE_ROUTE } from '../../../config';
import { useNavigate } from 'react-router-dom';

function OutsourcingShipEntry() {
    const navigate = useNavigate();
    const [ch_no, setChNo] = useState('');

    function query(){
        navigate(`${BASE_ROUTE}/outsourcing/ship/detail/${ch_no}`);
    }
    function isValidForm(){
        let q1 = ch_no !== '';
        return q1;
    }
    return (
        <div className={`bg-white p-3`}>
            <div className='container'>
            <div className='fs-6 mb-3'>外包出货单查询</div>
            <div className='d-flex align-items-center'>
                <FormControl
                    type='text'
                    value={ch_no}
                    onChange={e=>{
                        setChNo(e.currentTarget.value);
                    }}
                    placeholder='出货单号'
                />
                <Button variant='success' className='ms-2 text-nowrap' onClick={()=>{ query(); }} disabled={!isValidForm()}>查询</Button>
            </div>
            </div>
        </div>
    )
}

export default OutsourcingShipEntry